import React from 'react';
import { FormattedMessage } from 'react-intl';
import * as English from 'lang/en.json';
const SFormattedMessage = ({ id, values }) => {
    return (React.createElement(FormattedMessage, { id: id, values: values, defaultMessage: English[id] }));
};
export default SFormattedMessage;
